<template lang="pug">
.view-user
  ui-navbar-panel.mb-20(backLink="cronTasks", backLinkText="К списку")
    template(slot="filters")
      span Редактирование CRON-задачи # {{ this.$route.params.id }} &nbsp;
      b {{ task.command }}

    template
      b-button.is-primary(@click="save", icon-left="check", :disabled="!this.canEdit()") Сохранить

  .container(v-if="!task.$state.loading")
    form-component(
      v-model="task",
      form="edit-cron-task-form",
      ref="form"
    )
</template>

<script>
import BButton from 'buefy/src/components/button/Button';
import BField from 'buefy/src/components/field/Field';
import BIcon from 'buefy/src/components/icon/Icon';

import { mapGetters } from 'vuex';
import ServerJob from '@/models/ServerJob';

export default {
  name: 'view-edit-cron-task',
  components: { BIcon, BField, BButton },

  data: () => ({
    task: new ServerJob(),
  }),

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    $route() {
      this.loadState();
    },
  },

  methods: {
    canEdit() {
      return this.user.id === 1 || this.user.id === 4 || this.user.id === 93;
    },

    save() {
      this.$refs.form.save();
    },

    loadState() {
      if (this.$route.params.id) {
        this.task.id = +this.$route.params.id;
        this.task.$find(+this.$route.params.id, {
          include: 'platform.server',
        });
      }
    },
  },

  created() {
    this.loadState();
  },
};
</script>
